import script from "./VehicleForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleForm.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleForm.vue?vue&type=style&index=0&id=abe85190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abe85190"]])

export default __exports__